module.exports = __webpack_public_path__ + "static/img/autohaendler.8603619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404_page/teaser/autohaendler.jpg
// module id = lYVf
// module chunks = 1